export const ConnectionTypeEnum = {
    PRIVATE_LINK: 'private_link',
    PEERING: 'peering',
    BRIDGING: 'bridging'
} as const

export const AzConnectionSelectionEnum = {
    PUBLIC_IPS: "public_ips",
    VNET_PEERING: "vnet_peering"
} as const;

export const ConnectionTabEnum = {
    ConnectionMethod: "Connection Method"
} as const

export const AzurePrivateLinkEnum = {
    BASIC_SETTINGS: "Basic Settings",
    CREATE_A_SERVICE: "Create a Service",
    CREATE_A_PRIVATE_ENDPOINT: "Create a Private Endpoint",
    PROVIDE_ENDPOINT_NAME: "Provide Endpoint Name",
    SETUP_COMPLETE: "Setup Complete"
} as const

export const AWSPrivateLinkEnum = {
    DUMMY: "Dummy"
} as const

export const AzureVnetPeeringEnum = {
    NETWORK_INFORMATION: "Network Information",
    CONFIGURE_NETWORK_ROLES: "Configure Network Roles",
    CONFIGURE_PEERING: "Configure Peering",
    SETUP_COMPLETE: "Setup Complete"
} as const

export const AWSVnetPeeringEnum = {
    CONFIGURE_PEERING: "Configure Peering",
    ACCEPT_PEERING: "Accept Peering",
    ADD_ROUTE_TABLE_ENTRY: "Add Route Table Entry",
    SETUP_COMPLETE: "Setup Complete"
} as const

export const AzAddTrustedTenantTabsEnum = {
    ESTABLISH_TRUST_RELATIONSHIP: "Establish Trust Relationship Between Tenants",
    PROVIDE_TENANT_INFORMATION: "Provide Tenant Information",
    ACCEPT_GUEST_USER_INVITATION: "Accept Guest User Invitation",
    AUTHORIZE_NCACHE_APP_REGISTRATION: "Authorize NCache App Registration",
    TRUST_RELATIONSHIP_ESTABLISHED: "Trust Relationship Established"
} as const

export const CodeType = {
    Guest: "Guest",
    Contributor: "Contributor"
}

export const CreateAwsVpcPeeringEnum = {
    NEXT: "Next",
    CREATING_VPC_PEERING: "Creating VPC Peering",
    CREATING_ROUTE_ENTRY: "Creating Route Entry",
    CREATING_SECURITY_RULES: "Creating Security Rules"
}

export const AWSVpcPeeringStatuses = {
    INIT: "init",
    INVITE_SENT: "guest_invite_sent",
    ROLE_ASSIGNED: "role_assgined",
    PENDING: "pending",
    ACTIVE: "active",
    PENDING_ACCEPTANCE: "pending-acceptance",
    DELETING: "deleting",
    DELETED: "deleted",
    EXPIRED: "expired",
    REJECTED: "rejected",
    FAILED: "failed",
    DELETION_FAILED: "deletion_failed",
    AWAITING_ROUTE_ENTRY: "awaiting_route_entry",
    AWAITING_UPDATE_RULES: "awaiting_update_rules",
    UNKNOWN: "unknown"
} as const
  
export const AzureVnetPeeringStatuses = {
    INIT: "init",
    EXCHANGE_GUEST_ACCESS: "exchange_guest_access",
    INVITE_SENT: "guest_invite_sent",
    ROLE_ASSIGNED: "role_assgined",
    INITIATED: "Initiated",
    CONNECTED: "Connected",
    DISCONNECTED: "Disconnected",
    UPDATING: "Updating",
    DELETING: "Deleting",
    FAILED: "Failed",
    PENDING: "pending",
    UNKNOWN: "unknown"
} as const